<template>
  <div class="settings-page">
    <app-view-layout
      header="Ustawienia konta"
      fluid
    >
      <template #content>
        <SettingsUserData />
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import SettingsUserData from '@/components/Settings/SettingsUserData.vue';

export default {
  components: {
    AppViewLayout,
    SettingsUserData,
  },
};
</script>
